<section class="section section--statusMessage">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <div class="content__main flexColumn flexCenter">
          <article class="mainInfo mainInfo--center">
            <i class="icon icon-success mb-10" *ngIf="false">
              <app-success-icon color="color"></app-success-icon>
            </i>

            <i class="icon icon-error mb-10" *ngIf="true">
              <app-error-icon color="color"></app-error-icon>
            </i>

            <h1 class="pb-10">¡Firma realizada con éxito!</h1>
            <p>Has completado la firma digital del contrato correctamente.</p>
          </article>
        </div>

        <div class="content__footer">
          <button pButton pRipple type="submit" label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full"></button>
        </div>
      </div>
    </div>
  </div>
</section>
